// @flow
import DetailsParents from './DetailsParents';

export default DetailsParents;
